export default __webpack_public_path__ + "static/media/btnAdd.1f008a52.svg";